var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e94f37;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1853 6546) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 42,
    height: 42,
    rx: 8,
    transform: "translate(1811 6504)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 28,
    height: 28,
    transform: "translate(1818 6511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.8,8A19.8,19.8,0,1,1,8,27.8,19.8,19.8,0,0,1,27.8,8ZM25.493,19.465l6.028,5.78H16.942a1.912,1.912,0,0,0-1.916,1.916v1.277a1.912,1.912,0,0,0,1.916,1.916H31.521l-6.028,5.78a1.918,1.918,0,0,0-.032,2.739l.878.87a1.908,1.908,0,0,0,2.707,0L39.641,29.158a1.908,1.908,0,0,0,0-2.707l-10.595-10.6a1.908,1.908,0,0,0-2.707,0l-.878.87A1.928,1.928,0,0,0,25.493,19.465Z",
    transform: "translate(1804.2 6497.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftRed);
export default __webpack_public_path__ + "static/media/left-red.cfe44613a19c8bafc0d6c82c1b9477e3.svg";
export { ForwardRef as ReactComponent };